import {
    STARTPAGE,
    STANDARDPAGE,
    SEARCHPAGE,
    INFORMATIONPAGE,
    EVENTPAGE,
    JOBADPAGE,
    NEWSPAGE,
    EMPLOYEEPAGE,
    ERRORPAGE,
    MAPPAGE,
    FORMPAGE,
    COOKIELISTPAGE,
    ELEMENTPAGE,
    LISTWITHCATEGORY,
    LISTWITHCHILDREN,
    REPORTTECHNICALISSUEPAGE,
    FORMWITHCARDPAGE,
    MAPCITIESPAGE,
    MAPCITYPAGE
} from "Consts/pageTypes";
import StartPage from "Pages/StartPage";
import StandardPage from "Pages/StandardPage";
import CookieListPage from "Pages/CookieListPage";
import SearchPage from "Pages/SearchPage";
import ListPageWithCategories from "Pages/ListPageWithCategories";
import ListPageWithChildren from "Pages/ListPageWithChildren";
import ErrorPage from "Pages/ErrorPage";
import MapPage from "Pages/MapPage";
import FormPage from "Pages/FormPage";
import FormWithCardPage from 'Pages/FormWithCardPage';
import ElementPage from "Pages/ElementPage";
import RenderReportTechnicalUrlPage from "Pages/RenderReportTechnicalUrlPage"
import MapCitiesPage from "Pages/MapCitiesPage";

import React from "react";

export const getPageType = (model, Alias, searchQuery) => {
    switch (Alias) {
        case STARTPAGE:
            return <StartPage {...model} />;
        case STANDARDPAGE:
        case EVENTPAGE:
        case JOBADPAGE:
        case NEWSPAGE:
        case INFORMATIONPAGE:
        case EMPLOYEEPAGE:
            return <StandardPage {...model} menu={menu} Alias={Alias}/>;
        case SEARCHPAGE:
            return <SearchPage {...model} searchModel={searchQuery}/>;
        case LISTWITHCATEGORY:
            return <ListPageWithCategories {...model} searchModel={searchQuery}/>;
        case LISTWITHCHILDREN:
            return <ListPageWithChildren {...model} />;
        case ERRORPAGE:
            return <ErrorPage {...model} />;
        case MAPPAGE:
            return <MapPage {...model} />;
        case COOKIELISTPAGE:
            return <CookieListPage {...model} />;
        case FORMPAGE:
            return <FormPage/>;
        case FORMWITHCARDPAGE:
            return <FormWithCardPage/>;
        case ELEMENTPAGE:
            return <ElementPage {...model} />;
        case REPORTTECHNICALISSUEPAGE:
            return <RenderReportTechnicalUrlPage {...model} Alias={Alias}/>;
        case MAPCITIESPAGE:
        case MAPCITYPAGE:
            return <MapCitiesPage {...model} Alias={Alias}
                                  showBackButton={!model.HideBackToLocations && Alias === MAPCITYPAGE}/>;
        default:
            break;
    }
};
